module.exports = __webpack_public_path__ + "static/media/logoHeader.70fc9773.png";